import React from 'react'
import { List, ListItem } from '@mobi/component-library/Base/List'
import { Constants } from '@mobi/settings/constants'
import { useServerConfig } from '@core/Data/ServerConfig/useServerConfig'
import { fullClientVersion } from '@core/Utils/clientVersion'

export const VersionInfo = () => {
  const config = useServerConfig()
  const versionInfo = window?.TABTOUCH?.versionInfo
  const serverVersion = config ? `${config.serverVersion} (${config.serverEnvironment})` : 'Unknown'

  return (
    <>
      <List title='Version Info' variant='card'>
        <ListItem text='Server Version' contentRight={serverVersion} />
        <ListItem text='Client Version (from bundle)' contentRight={fullClientVersion} />
      </List>

      {versionInfo && (
        <List title='Index Details' variant='card'>
          <ListItem text='Client Version' contentRight={versionInfo.version} />
          <ListItem text='Git Branch' contentRight={versionInfo.gitRefName} />
          <ListItem
            text='Git Commit SHA'
            contentRight={
              <a
                href={`${Constants.GitHubProjectUrl}commit/${versionInfo.gitCommitSha}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                {versionInfo.gitCommitSha.substring(0, 7)}
              </a>
            }
          />
          <ListItem text='User' contentRight={versionInfo.gitHubActor} />
          <ListItem
            text='GitHub Workflow'
            contentRight={
              <a
                href={`${Constants.GitHubProjectUrl}actions/runs/${versionInfo.gitHubRunId}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                Open
              </a>
            }
          />
        </List>
      )}
    </>
  )
}
